import { database } from "../firebase";

export const writeLiveChatInfo = async (chatId, info, method = "update") => {
  if (!chatId || !info || typeof info !== "object") {
    return;
  }

  const infoRef = database.ref(`liveChat/${chatId}/info`);
  const metaRef = database.ref(`liveChatMeta/${chatId}`);

  await infoRef[method](info);

  try {
    await metaRef[method](info);
  } catch (error) {
    console.warn("Failed to sync liveChatMeta; continuing with liveChat/info only.", error);
  }
};
